// API configuration
// In production, prefer same-origin relative path so FE/BE on one host works without CORS
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? '/api'
    : 'http://localhost:3000/api');

export { API_URL }; 